import React, { PureComponent } from 'react';
import T from 'prop-types';
// redux
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchStep } from '../../../redux/reducers/module';
// hoc
import withSizes from 'react-sizes';
// utils
import get from 'lodash.get';
// styles
import styles from './SatisfactionTable.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

class SatisfactionTable extends PureComponent {
  componentDidMount() {
    const { fetchStep, id } = this.props;
    fetchStep(id);
  }

  render() {
    const { data, isMobile, isDesktop } = this.props;
    const tableData = get(data, 'content.satisfaction_info');

    const isStartHidden = !tableData[0].hasOwnProperty('start_day');
    const isEndHidden = !tableData[0].hasOwnProperty('end_day');
    const isDifferenceHidden = !tableData[0].hasOwnProperty('difference');

    if (isStartHidden && isEndHidden && isDifferenceHidden) {
      return null;
    }

    if (isDesktop) {
      return (
        <div className={cx('wrapper')}>
          <div className={cx('container')}>
            <div className={cx('row', 'heading')}>
              <span className={cx('title-cell')} />
              <span className={cx('cell', { hidden: isStartHidden })}>
                Start date
              </span>
              <span className={cx('cell', { hidden: isEndHidden })}>
                End date
              </span>
              <span className={cx('cell', { hidden: isDifferenceHidden })}>
                Difference
              </span>
            </div>
            {tableData.map(
              ({ id, title, difference, end_day, start_day }, index) => (
                <div className={cx('row')} key={id || index}>
                  <span className={cx('title-cell')}>{title}</span>
                  <span className={cx('cell', { hidden: isStartHidden })}>
                    {start_day}%
                  </span>
                  <span className={cx('cell', { hidden: isEndHidden })}>
                    {end_day}%
                  </span>
                  <span className={cx('cell', { hidden: isDifferenceHidden })}>
                    {difference}%
                  </span>
                </div>
              )
            )}
          </div>
        </div>
      );
    }

    if (isMobile) {
      return (
        <div className={cx('wrapper')}>
          <div className={cx('container', 'mobile')}>
            {tableData.map(
              ({ id, title, difference, end_day, start_day }, index) => (
                <div className={cx('row')} key={id || index}>
                  <span className={cx('title-cell')}>{title}:</span>
                  <span className={cx('inner-row', { hidden: isStartHidden })}>
                    <span className={cx('cell')}>Start date:</span>
                    <span className={cx('cell')}>{start_day}%</span>
                  </span>
                  <span className={cx('inner-row', { hidden: isEndHidden })}>
                    <span className={cx('cell')}>End date:</span>
                    <span className={cx('cell')}>{end_day}%</span>
                  </span>
                  <span
                    className={cx('inner-row', { hidden: isDifferenceHidden })}
                  >
                    <span className={cx('cell')}>Difference:</span>
                    <span className={cx('cell')}>{difference}%</span>
                  </span>
                </div>
              )
            )}
          </div>
        </div>
      );
    }
  }
}

SatisfactionTable.propTypes = {
  isDesktop: T.bool.isRequired,
  isMobile: T.bool.isRequired,
  fetchStep: T.func.isRequired,
  id: T.number.isRequired,
  data: T.shape({
    content: T.shape({
      satisfaction_info: T.arrayOf(
        T.shape({
          id: T.number,
          title: T.string,
          difference: T.number,
          end_day: T.number,
          start_day: T.number
        })
      )
    })
  }).isRequired
};

const enhance = compose(
  connect(
    null,
    { fetchStep }
  ),
  withSizes(({ width }) => ({
    isMobile: width < 768,
    isDesktop: width >= 768
  }))
);

export default enhance(SatisfactionTable);



// WEBPACK FOOTER //
// ./src/containers/Module/components/SatisfactionTable.jsx